<template>
  <div class="page--crud_list">
    <div class="tab-content">
      <vxe-table
          ref="table"
          class="main-table"
          size="mini"
          border
          show-header-overflow
          show-overflow
          highlight-hover-row
          :empty-text="$t('label.no_data_found')"
          
          :key="new Date().getTime()"
          :resizable="true"
          :data="data">

        <vxe-table-column
            v-for="(field) in currentSetting" :key="field.key"
            :field="field.key"
            :title="field.key"
            :class-name="'test'"
            :width="field.width"
        >
          <template v-slot:header="{ columnIndex }">
            <div class="header-wrap">
              <div class="name">
                {{ tran(key, currentSetting[columnIndex].key) }}
              </div>
            </div>
          </template>
          <template v-slot="{ row }">
            <div v-if="field.type == 'boolean'">
              <input class="custom-checkbox" type="checkbox" v-model="row[field.key]" disabled="disabled">
              <div class="block-layer"></div>
            </div>

            <div v-else-if="field.type == 'datetime'">
              {{ row[field.key] ? $moment(row[field.key]).format("YYYY-MM-DD HH:mm:ss") : field.fill ? $moment().format("YYYY-MM-DD HH:mm:ss") : "" }}
            </div>

            <div v-else-if="field.type == 's_to_hms'">
              {{ row[field.key] ? getTime(row[field.key]) : "00:00:00" }}
            </div>
            <div class="action" v-else-if="field.type == 'action-btn'" >
              <el-button
                  type="primary"
                  size="mini"
                  @click="editCpConfig(row)"
              >
                <fa :icon="['fas', 'edit']"/>
              </el-button>
              <el-button
                  type="info"
                  size="mini"
                  @click="duplicateCpConfig(row)"
              >
                <fa :icon="['fas', 'clone']"/>
              </el-button>
              <el-button
                  type="danger"
                  size="mini"
                  @click="deleteCpConfig(row.cp_config_id)"
              >
                <fa :icon="['fas', 'trash-alt']"/>
              </el-button>
            </div>

            <div v-else-if="field.type == 'float'">
              {{ getFloating( field, field.hasOwnProperty("field") ? getValueByField(row, field) : row[field.key] ) }}
            </div>

            <div v-else>{{ field.hasOwnProperty("field") ? getValueByField(row, field) : row[field.key] }}</div>

          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  created() {
    console.log("data: " , this.data);
    
  },
  async beforeMount() {
    
    await this.$axios.get(`/../cp_sessions_trans`, {
      params: {
          cp: this.$route.params.cp
        }
    }).then(res=>{
      let data = res.data.response.dataset.content;
      this.data = data;
      return true;
    }).catch(err=>{ return false; });
  },
  methods: {
    getFloating(field, value) {
      if(field.decimal_point) {
        return (value/1000).toFixed(field.decimal_point);
      }else {
        return value/1000;
      }
    },
    fillZero(num) {
      num = Math.abs(num);
      return num < 10 ? `0${num}` : num;
    },
    getTime(sec) {
      // let h = Math.abs(Math.floor(sec/(60*60)));
      let h = Math.floor(sec/(60*60));
      let m = Math.floor(sec/(60)) - h*60;
      let s = sec%60;

      if(sec > 0) {
        return `${this.fillZero(h)}:${this.fillZero(m)}:${this.fillZero(s)}`;
      }else {
        return `-${this.fillZero(h)}:${this.fillZero(m)}:${this.fillZero(s)}`;
      }
    }
  },
  data() {
    return {
      key: "cp_sessions_all",
      selectedIndex : -1,
      selectedConfig : null,
      isCreate: false,
      cpConfigData: null,
      fwVerConfig: [],
      currentSetting:[
        { key: "session_id"},
        { key: "account_id", field: "account_id.car_reg_no" },
        // { key: "id_tag" },
        // { key: "cp_no", field: "cp_id.cp_no" },
        // { key: "cp_name", field: "cp_id.name" },
        // { key: "charge_box_serial_number", field: "cp_id.charge_box_serial_number", width: 90 },
        { key: "connector_id", field: "connector_id" },
        { key: "total_charge_time", type: "s_to_hms" },
        { key: "total_pw_consume", type: "float", decimal_point: 3 },
        // { key: "running_pw_consume", type: "float", decimal_point: 3 },
        // { key: "session_start_time", type: "datetime" },
        // { key: "start_meter", type: "float", decimal_point: 3 },
        // { key: "session_end_time", type: "datetime", fill: false },
        // { key: "end_meter", type: "float", decimal_point: 3 },
        // { key: "cre_dttm", type: "datetime" },
        { key: "start_soc" },
        { key: "end_soc" },
      ],
      data:[]
    }
  }
}
</script>

<style lang="scss">
  #top{display: none;}
  .vxe-table--body {
    .row-clicked {
      background: #ffe48d;
    }
    .action {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      :first-child{
        margin-right: 0px !important;
      }
      &:not(:first-child) {
        margin-left: 0px !important;
      }
      .el-button{
        padding: 7px 7px;
      }
    }
  }
  .ver-btn {
    margin: 8px;
  }
</style>